// extracted by mini-css-extract-plugin
export default {"errorMessage":"ALMErrorBoundary_errorMessage__6XegA"};